var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.maxNumber),function(i){return _c('font-awesome-icon',{key:'heart_'+i,staticClass:"heart",style:(_vm.heartStyle()),attrs:{"icon":_vm.icon()}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }